const makeSelectOption = (item) => ({
  ...item,
  value: item.price,
  label: item.title,
});

export { makeSelectOption };
